export const jkitElements = [
    {
        name: 'jkit_nav_menu',
        title: 'Nav Menu',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_off_canvas',
        title: 'Off Canvas',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_search',
        title: 'Search',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_icon_box',
        title: 'Icon Box',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_image_box',
        title: 'Image Box',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_fun_fact',
        title: 'Fun Fact',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_progress_bar',
        title: 'Progress Bar',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_client_logo',
        title: 'Client Logo',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_testimonials',
        title: 'Testimonials',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_accordion',
        title: 'Accordion',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_gallery',
        title: 'Gallery',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_team',
        title: 'Team',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_pie_chart',
        title: 'Pie Chart',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_portfolio_gallery',
        title: 'Portfolio Gallery',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_tabs',
        title: 'Tabs',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_animated_text',
        title: 'Animated Text',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_heading',
        title: 'Heading',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_countdown',
        title: 'Countdown',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_button',
        title: 'Button',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_dual_button',
        title: 'Dual Button',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_video_button',
        title: 'Video Button',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_social_share',
        title: 'Social Share',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_post_block',
        title: 'Post Block',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_post_list',
        title: 'Post List',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_category_list',
        title: 'Category List',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_feature_list',
        title: 'Feature List',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_contact_form_7',
        title: 'Contact Form 7',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_mailchimp',
        title: 'Mailchimp',
        category: 'jkit-elements'
    },
    {
        name: 'jkit_post_title',
        title: 'Post Title',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_featured_image',
        title: 'Post Featured Image',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_comment',
        title: 'Post Comment',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_terms',
        title: 'Post Terms',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_excerpt',
        title: 'Post Excerpt',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_date',
        title: 'Post Date',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_author',
        title: 'Post Author',
        category: 'jkit-post'
    },
    {
        name: 'jkit_post_content',
        title: 'Post Content',
        category: 'jkit-post'
    },
    {
        name: 'jkit_banner',
        title: 'Banner',
        category: 'jkit-elements'
    }
];

const pro = [


]



export const getJkitElements = () => {
    const { wooCommerceActice } = window['JkitDashboardOption'];

    const jkitElements = [
        {
            name: 'jkit_nav_menu',
            title: 'Nav Menu',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_off_canvas',
            title: 'Off Canvas',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_search',
            title: 'Search',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_icon_box',
            title: 'Icon Box',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_image_box',
            title: 'Image Box',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_fun_fact',
            title: 'Fun Fact',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_progress_bar',
            title: 'Progress Bar',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_client_logo',
            title: 'Client Logo',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_testimonials',
            title: 'Testimonials',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_accordion',
            title: 'Accordion',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_gallery',
            title: 'Gallery',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_team',
            title: 'Team',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_pie_chart',
            title: 'Pie Chart',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_portfolio_gallery',
            title: 'Portfolio Gallery',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_tabs',
            title: 'Tabs',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_animated_text',
            title: 'Animated Text',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_heading',
            title: 'Heading',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_countdown',
            title: 'Countdown',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_button',
            title: 'Button',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_dual_button',
            title: 'Dual Button',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_video_button',
            title: 'Video Button',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_social_share',
            title: 'Social Share',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_post_block',
            title: 'Post Block',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_post_list',
            title: 'Post List',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_category_list',
            title: 'Category List',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_feature_list',
            title: 'Feature List',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_contact_form_7',
            title: 'Contact Form 7',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_mailchimp',
            title: 'Mailchimp',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_post_title',
            title: 'Post Title',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_featured_image',
            title: 'Post Featured Image',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_comment',
            title: 'Post Comment',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_terms',
            title: 'Post Terms',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_excerpt',
            title: 'Post Excerpt',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_date',
            title: 'Post Date',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_author',
            title: 'Post Author',
            category: 'jkit-post'
        },
        {
            name: 'jkit_post_content',
            title: 'Post Content',
            category: 'jkit-post'
        },
        {
            name: 'jkit_banner',
            title: 'Banner',
            category: 'jkit-elements'
        },
        {
            name: 'jkit_pro_hotspot',
            title: 'Hotspot',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_timeline',
            title: 'Timeline',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_archive_title',
            title: 'Archive Title',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_archive_description',
            title: 'Archive Description',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_back_to_top',
            title: 'Back To Top',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_text_background',
            title: 'Text Background',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_breadcrumb',
            title: 'Breadcrumb',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_text_marquee',
            title: 'Text Marquee',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_horizontal_accordion',
            title: 'Horizontal Accordion',
            category: 'jkit-elements',
            pro: true,
        },
        {
            name: 'jkit_pro_charts',
            title: 'Charts',
            category: 'jkit-elements',
            pro: true,
        },
    ];

    if (wooCommerceActice) {
        jkitElements.push(
            {
                name: 'jkit_product_grid',
                title: 'Product Grid',
                category: 'jkit-woo'
            },
            {
                name: 'jkit_product_carousel',
                title: 'Product Carousel',
                category: 'jkit-woo'
            },
            {
                name: 'jkit_product_categories',
                title: 'Product Categories',
                category: 'jkit-woo'
            },
            {
                name: 'jkit_pro_product_custom_add_to_cart',
                title: 'Product Custom Add To Cart',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_title',
                title: 'Product Single Title',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_breadcrumb',
                title: 'Product Single Breadcrumb',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_images',
                title: 'Product Single Images',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_price',
                title: 'Product Single Price',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_rating',
                title: 'Product Single Rating',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_description',
                title: 'Product Single Description',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_content',
                title: 'Product Single Content',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_related',
                title: 'Product Single Related',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_add_to_cart',
                title: 'Product Single Add To Cart',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_stock',
                title: 'Product Single Stock',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_additional_information',
                title: 'Product Single Additional Information',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_meta',
                title: 'Product Single Meta',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_single_data_tabs',
                title: 'Product Single Data Tabs',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_product_archive',
                title: 'Product Archive',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_woocommerce_cart_page',
                title: 'Woocommerce Cart Page',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_woocommerce_checkout_page',
                title: 'Woocommerce Checkout Page',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_woocommerce_account_page',
                title: 'Woocommerce Account Page',
                category: 'jkit-woo',
                pro: true,
            },
            {
                name: 'jkit_pro_woocommerce_menu_cart',
                title: 'Woocommerce Menu Cart',
                category: 'jkit-woo',
                pro: true,
            }
        )
    }
    return jkitElements;
}
